import React, { useState } from 'react';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiCancelIcon from '@material-ui/icons/Cancel';
import MuiSaveIcon from '@material-ui/icons/Save';
import MuiEditIcon from '@material-ui/icons/Edit';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiTextField from '@material-ui/core/TextField';
import MuiBox from '@material-ui/core/Box';
import * as API from 'api';

import { formatDate, formatCurrency } from '../RecoupAccounts';

const RecoupLedger = API.RecoupLedgers();

export default function TransactionRow({ ledger, refetch, account }) {
  const { effective_at, notes, source, amount_usd, voided } = ledger;
  const formattedDate = formatDate(effective_at, true);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [notesForm, setNotesForm] = useState(notes || '');

  async function voidEntry() {
    await RecoupLedger.editLedger(ledger.id, { voided: true });
    setIsDialogOpen(false);
    await refetch();
  }

  async function handleClick() {
    if (!isEditingNote) return setIsEditingNote(true);
    await RecoupLedger.editLedger(ledger.id, { notes: notesForm });
    setIsEditingNote(false);
    await refetch();
  }

  async function updateNote({ target: { value } }) {
    setNotesForm(value);
  }

  return (
    <>
      <MuiTableRow>
        <MuiTableCell>{formattedDate}</MuiTableCell>
        <MuiTableCell>
          <MuiBox style={{ width: '20rem', display: 'flex' }}>
            <MuiButton
              onClick={handleClick}
              size="small"
              disabled={voided}
              startIcon={isEditingNote ? <MuiSaveIcon /> : <MuiEditIcon />}
            />
            {!isEditingNote ? (
              voided ? (
                `VOIDED: ${notes}`
              ) : (
                notes
              )
            ) : (
              <MuiTextField
                value={notesForm}
                onChange={updateNote}
                label="Notes"
                variant="outlined"
                id="notes"
                multiline
                minRows={3}
                maxRows={6}
              />
            )}
          </MuiBox>
        </MuiTableCell>
        <MuiTableCell>{source}</MuiTableCell>
        <MuiTableCell align="right">{formatCurrency(amount_usd)}</MuiTableCell>
        <MuiTableCell>
          <MuiButton startIcon={<MuiCancelIcon />} onClick={() => setIsDialogOpen(true)}></MuiButton>
        </MuiTableCell>
      </MuiTableRow>
      <MuiDialog open={isDialogOpen}>
        <MuiDialogContent>
          <div>Are you sure you want to void this ledger entry?</div>
          <MuiButton variant="contained" size="small" onClick={voidEntry}>
            Yes, Void leger entry.
          </MuiButton>
          <MuiButton variant="contained" size="small" onClick={() => setIsDialogOpen(false)}>
            No, cancel.
          </MuiButton>
        </MuiDialogContent>
      </MuiDialog>
    </>
  );
}
